import http from './reddit'
export default {
  // 会员列表
  tb: (siteState) => http.Get(`${http.url.Newcommon}/maaclt/${siteState}`),
  // 站台管理 -> 新增站台    
  adduser: (data) => http.Post(`${http.url.Newcommon}/maadpo`, data),
  // 站台管理 -> 取得 修改頁面基本資料  
  mauge: (id = '') => http.Get(`${http.url.Newcommon}/mauge/${id}`),
  // 站台管理 -> 修改頁面上傳公司logo 客服圖片 及 登入碼      
  memdebr: (id = '') => http.Get(`${http.url.Newcommon}/memdeb/${id}`),
  // 站台管理 -> 修改站台資料   
  update_member: (data) => http.Post(`${http.url.Newcommon}/maupo`, data),
  // 站台管理 -> 停用功能
  stop_memdebr: (data) => http.Post(`${http.url.Newcommon}/aco`, data),
  // 站台管理 -> 遊戲管理列表資料
  memgamelist: (listid) => http.Get(`${http.url.Newcommon}/memgamelist/` + listid),
  // 站台管理 -> 遊戲管理更新資料
  memgamelist_update: (data) => http.Post(`${http.url.Newcommon}/memgameupd`, data),
  //站台管理 日誌
  stop_logoddchtable: (passdate = '', nowdate = '', pid = '') => http.Get(`${http.url.Newcommon}/logoddchtable/${passdate}/${nowdate}/${pid}`),
  //站台管理 圖片上傳
  fileUpload: (data) => http.fileUpload(data),
  // 玩法連動列表
  accms: (gameid, id) => http.Get(`${http.url.hfl}/accms/${gameid}/${id}`),
  // 修改玩法連動操作
  memlinkoddsupd: (data) => http.Post(`${http.url.Newcommon}/memlinkoddsupd`, data),
  test_update: (data) => http.Post('http://readytoli2.local.host/v2/test/test', data),
  memaddgame: (data) => http.Post(`${http.url.Newcommon}/memaddgame`, data),
  // 站点设置
  sitesettings: (id = '') => http.Get(`${http.url.Newcommon}/sitesettings/${id}`),
  update_settings: (data) => http.Post(`${http.url.Newcommon}/sitesettingsupd`, data),
}